import {
  createMutationHookObject,
  GetMutationParams,
  GetMutationResults,
  Mutations,
} from 'entities/_config';

import { authMutations } from './auth/mutations';
import { userMutations } from './users/mutations';
import { wppMutations } from './whatsapp/mutations';
import { rewardMutations } from './rewards/mutations';

// enforce intellisense and permission <> key
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function buildMutations<AppMutations extends Record<string, Mutations<any>>>(
  mutations: AppMutations,
): AppMutations {
  return mutations;
}

const entityMutations = buildMutations({
  auth: authMutations,

  users: userMutations,

  whatsapp: wppMutations,

  rewards: rewardMutations,
});

export type EntityMutations = typeof entityMutations;

export type MutationParams = GetMutationParams<EntityMutations>;
export type MutationResults = GetMutationResults<EntityMutations>;

export const mutations = createMutationHookObject(entityMutations);
